import { createReducer, on } from '@ngrx/store';
import { Config, ConfigEditorDetailVariant } from '../domain/config';
import * as Actions from './config-editor-screen.actions';

export const featureKey = 'cxbConfigEditorScreen';

export interface FeatureState {
  configs: Config[];
  config: Config;
  variant: ConfigEditorDetailVariant;
  loading: boolean;
}

export interface AppState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  configs: undefined,
  config: undefined,
  variant: undefined,
  loading: false,
};

export const reducer = createReducer(
  initialState,
  on(Actions.loadCxbConfigEntries, (state): FeatureState => ({ ...state, configs: undefined, loading: true })),
  on(Actions.loadCxbConfigEntriesSuccess, (state, action): FeatureState => ({ ...state, configs: action.configs, loading: false })),
  on(Actions.loadCxbConfigEntriesFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.loadCxbConfigEntry, (state): FeatureState => ({ ...state, config: undefined, loading: true })),
  on(
    Actions.loadCxbConfigEntrySuccess,
    (state, action): FeatureState => ({ ...state, config: action.config, variant: action.variant, loading: false })
  ),
  on(Actions.loadCxbConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.leaveConfigEditorDetailScreen, (state): FeatureState => ({ ...state, config: undefined, variant: undefined })),

  on(Actions.createCxbConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.createCxbConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.createCxbConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.updateCxbConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.updateCxbConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.updateCxbConfigEntryFail, (state): FeatureState => ({ ...state, loading: false })),

  on(Actions.deleteCxbConfigEntry, (state): FeatureState => ({ ...state, loading: true })),
  on(Actions.deleteCxbConfigEntrySuccess, (state): FeatureState => ({ ...state, loading: false })),
  on(Actions.deleteCxbConfigEntryFail, (state): FeatureState => ({ ...state, loading: false }))
);
